import {FC, useState} from 'react';
import {Box, IconButton, Typography} from '@mui/material';
import {useNavigate} from 'react-router-dom';
import {ROUTER_URL} from '@/utils/enums';
import {ReactComponent as Arrow} from '@icons/arrow-down.svg';
import {organizationDropdownStyle} from '@/layouts/OrganizationTemplate/OrganizationHeader/OrganizationDropdown/OrganizationDropdown.styles';
import {BODY1, IMAGE_AVATAR_ALT, SUBTITLE2} from '@/utils/constants';
import Dropdown from '@/shared/components/Dropdown';
import {adminStorage} from '@/utils/services';
import {getSuperAdminSelector, superAdminLogout} from '@/store/admin';
import {useAppDispatch} from '@/store/hooks';
import {useSelector} from 'react-redux';
import adminIcon from '@images/admin-logo.png';

const AdminDropdown: FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const admin = useSelector(getSuperAdminSelector);

  const [isOpened, setIsOpened] = useState(false);
  const ADMIN_PROFILE_PATH = `${ROUTER_URL.ADMIN}/${ROUTER_URL.PROFILE}`;

  const handleProfileClick = () => {
    adminStorage.set('activeTab', 'Profile');
    navigate(`${ADMIN_PROFILE_PATH}/${ROUTER_URL.PROFILE_GENERAL}`);
  };

  const handleNotificationClick = () => {
    adminStorage.set('activeTab', 'Notifications');
    navigate(`${ADMIN_PROFILE_PATH}/${ROUTER_URL.PROFILE_NOTIFICATION}`);
  };

  const handleBillingClick = () => {
    adminStorage.set('activeTab', 'Billing');
    navigate(`${ADMIN_PROFILE_PATH}/${ROUTER_URL.ADMIN_PROFILE_BILLING}`);
  };

  const handleLogout = () => {
    dispatch(superAdminLogout());
    navigate(ROUTER_URL.ADMIN);
  };

  return (
    <Dropdown
      toggleContent={
        <Box sx={organizationDropdownStyle.wrap}>
          <IconButton sx={organizationDropdownStyle.avatar}>
            <img src={adminIcon} alt={IMAGE_AVATAR_ALT} />
          </IconButton>
          <Box sx={organizationDropdownStyle.info}>
            <Typography variant={BODY1}>{admin?.name}</Typography>
            <Typography variant={SUBTITLE2} sx={organizationDropdownStyle.email}>
              {admin?.email}
            </Typography>
          </Box>
          <IconButton
            disableRipple
            sx={{...organizationDropdownStyle.dropdownIcon, ...(isOpened && organizationDropdownStyle.rotateArrow)}}
          >
            <Arrow />
          </IconButton>
        </Box>
      }
      options={
        <Box sx={organizationDropdownStyle.options}>
          <Typography onClick={handleProfileClick} sx={organizationDropdownStyle.option} variant={BODY1}>
            Profile
          </Typography>
          <Typography onClick={handleNotificationClick} sx={organizationDropdownStyle.option} variant={BODY1}>
            Notifications
          </Typography>
          <Typography onClick={handleBillingClick} sx={organizationDropdownStyle.option} variant={BODY1}>
            Billing
          </Typography>
          <Typography sx={organizationDropdownStyle.option} variant={BODY1} onClick={handleLogout}>
            Log out
          </Typography>
        </Box>
      }
      open={isOpened}
      onOpen={() => setIsOpened(true)}
      onClose={() => setIsOpened(false)}
    />
  );
};

export default AdminDropdown;
